import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { PoButtonModule } from '@po-ui/ng-components';

@Component({
  standalone: true,
  selector: 'app-not-found',
  imports: [PoButtonModule],
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.css'
})
export class NotFoundComponent {
  constructor(private router: Router) {}

  goHome(): void {
    this.router.navigate(['/home']);
  }

  openDocumentation(): void {
    window.open('https://tdn.totvs.com/x/_3-RNw', '_blank');
  }
}
